import lazyLoading from './modules/lazyLoading';
import { Fancybox } from "@fancyapps/ui";
import video from "./components/video";
import quiz from "./components/quiz";
import animation from "./components/animation";
import form from "./components/form";
import './components/swipers';
import './components/mask';
import './components/map';


Fancybox.bind("[data-fancybox]", {
	dragToClose: false,
	autoFocus: false
});

lazyLoading.init();
animation.init();
video.init();
quiz.init();
form.init();
